import { makeStyles, createStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) =>
  createStyles({
    telInput: {
      textAlign: theme.direction === 'rtl' ? 'end' : 'start',
    },
  }),
);
